/* Advertorial — interactive behaviour
 * Smooth scroll for anchor links inside the advertorial scope.
 * Self-initialising, idempotent.
 */
(function () {
  if (window.__advertorialPageInit) return;
  window.__advertorialPageInit = true;

  // Smooth scroll for in-page anchor links
  document.addEventListener('click', function (e) {
    var link = e.target.closest('.advertorial-scope a[href^="#"]');
    if (!link) return;
    var href = link.getAttribute('href');
    if (!href || href === '#') return;
    var target = document.querySelector(href);
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();
